import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const FiveGRadar: Site = {
  id: '5gradar',
  logo: 'svg/5gradar.svg',
  label: '5G Radar',
  analyticsName: '5gradar',
  hostname: '5gradar.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
